module.exports = __webpack_public_path__ + "static/media/hero-3.d95ff68f.jpg";